import { Link } from 'react-router-dom';
import { Box } from '@mui/material';

export const ResetPasswordInvalidPage: React.FC = () => {
  return (
    <Box className="row text-center">
      <h3 className="col-md-12">Password reset is invalid</h3>
      <Link to="/password/forgot" className="col-md-12">
        Ask for a new password reset
      </Link>
    </Box>
  );
};
